<p-tabView  >
        <p-table #dt1 [value]="products" responsiveLayout="scroll" styleClass="p-datatable-gridlines" 
        [lazy]="true" [paginator]="true" [totalRecords]="totalRecord" [rows]="pageSize" [showCurrentPageReport]="true" (onPage)="getPosDetailsData($event)" 
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" selectionMode="single" [rowsPerPageOptions]="rowsPerPage"
        [first]="first" selectionMode="single" [(selection)]="selectedProduct" (onRowSelect)="onRowSelect($event)" 
        dataKey="id" paginatorDropdownAppendTo="body">

            <ng-template pTemplate="header">
                <tr [pSelectableRow]="rowData">
                    <th id="name">Name</th>
                    <th id="item">Item</th>
                    <th id="type">Type</th>
                    <th id="product categories">Product Categories</th>
                    <th id="manufacter name">Manufacter Name</th>
                    <th id="barcode">Barcode</th>
                    <th id="buy price">Buy Price</th>
                    <th id="sell price">Sell Price </th>
                    <th id="qty in hand">Qty in hand </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr [pSelectableRow]="product">
                    <td>{{product.name}}</td>
                    <td>{{product.itemNo}}</td>
                    <td>{{product.type}}</td>
                    <td>{{product.productCategories}}</td>
                    <td>{{product.manufacturerName}}</td>
                    <td>{{product.barCode}}</td>
                    <td>{{product.buyPrice}}</td>
                    <td>{{product.sellPrice}}</td>
                    <td>{{product.availableToSellQty}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td colspan="12" class="p-text-center">{{noPosDetailsFindOrLoadingText}}</td>
                </tr>
            </ng-template>
        </p-table>
</p-tabView>

<app-pos-view [display]="display" [posView]="posView"  (close)="onClose()"></app-pos-view>
<p-toast [baseZIndex]="1000000"></p-toast>

